import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { PatientDatum } from 'src/app/model/Patient';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-patients-item',
  templateUrl: './patients-item.component.html',
  styleUrls: ['./patients-item.component.scss'],
})
export class PatientsItemComponent implements OnInit {
  @Input() patient: PatientDatum;
  @Output() handleClick: EventEmitter<PatientDatum> = new EventEmitter();
  public avatarUrl: any;

  constructor(private http: HttpClient, private router: Router) {}

  ngOnInit(): void {
    this.getAvatar();
  }

  handleDetailClick(patient: PatientDatum) {
    this.handleClick.emit(patient);
  }

  getAvatar() {
    // Debug
    // return;
    return this.http
      .get(`${environment.NEW_API}/patients/${this.patient.id}/image`, {
        responseType: 'blob',
      })
      .subscribe((data: any) => {
        return this.createImageFromBlob(data);
      });
  }

  createImageFromBlob(image: Blob) {
    let reader = new FileReader();
    reader.addEventListener(
      'load',
      () => {
        this.avatarUrl = reader.result;
      },
      false
    );

    if (image) {
      reader.readAsDataURL(image);
    }
  }

  goToPazienteProfile(patientId: any): void {
    this.router.navigate(['/profilo-paziente', patientId]);
  }
}
